// extracted by mini-css-extract-plugin
export default {"iconContainer":"beachLineFeature-module__iconContainer__3NsS6","iconLabel":"beachLineFeature-module__iconLabel__i8LCG"};